import moment from "moment";

const TrackInfoComponent = ({
  value: { shipmentinfo, deliveryinfo, checkpoints, shipmentsummary },
}) => (
  <div className="flex justify-center items-center mb-[8rem]">
    <div className="w-[70rem]  shadow-card p-8 mx-[1rem]">
      <div className="md:flex grid gap-4">
        <div className="bg-[#f8f8f8] flex-1 p-[1rem]">
          <h2 className="font-bold text-lg mb-2">Shipment Booking Details</h2>
          <p className="text-gray-400 text-md">
            Tracking Number:
            <span className="text-lg text-[#f0575d] font-bold pl-[4rem]">
              {shipmentinfo && shipmentinfo[0].consignmentno}
            </span>
          </p>
          <h2 className="font-bold text-md my-1">Shipment Details:</h2>
          <div className="flex">
            <p className="w-[12rem] text-gray-400">Agent Reference Number:</p>
            <p className="font-bold text-400">
              {shipmentinfo && shipmentinfo[0].referenceno}
              {/*  */}
            </p>
          </div>
          <div className="flex">
            <p className="w-[10rem]  text-gray-400">Origin:</p>
            <p className="font-bold text-[1rem] pl-[2rem]">
              {shipmentinfo && shipmentinfo[0].origin}
            </p>
          </div>
          <div className="flex">
            <p className="w-[10rem]  text-gray-400">Destination:</p>
            <p className="font-bold pl-[2rem]">
              {shipmentinfo && shipmentinfo[0].destination}
            </p>
          </div>
          <div className="flex">
            <p className="w-[10rem]  text-gray-400">Booking Date:</p>
            <p className="font-bold pl-[2rem]">
              {shipmentinfo && shipmentinfo[0].bookingdate}
            </p>
          </div>
        </div>
        <div className="bg-[#f8f8f8] flex-1 p-[1rem]">
          <h2 className="font-bold text-lg mb-2">Shipment Track Summary</h2>
          <p className="text-gray-400">
            Current Status:
            <span className="text-md text-[#f0575d] font-bold ml-[5px]">
              {deliveryinfo && deliveryinfo[0].status}
            </span>
          </p>
          {deliveryinfo && deliveryinfo[0].status === "Delivered" && (
            <>
              <div className="flex">
                <p className="w-[7rem]  text-gray-400">Delivered On:</p>
                <p className="font-bold">{deliveryinfo[0].datetime}</p>
              </div>
              <div className="flex">
                <p className="w-[7rem]  text-gray-400">Received by:</p>
                <p className="font-bold">{deliveryinfo[0].recievedby}</p>
              </div>
            </>
          )}
        </div>
      </div>
      {checkpoints && !!checkpoints?.length && (
        <>
          <div className="bg-[#f8f8f8]  p-[1rem] mt-[2rem] ">
            {shipmentsummary != null &&
              shipmentsummary
                .split(/\n/)
                .map((line) => <div key={line}>{line}</div>)}
          </div>
          <h2 className="text-3xl font-semibold text-center mt-[3rem] mb-[1rem]">
            Track History
          </h2>
          <div className="flex-1 mb-2">
            <table className="mt-6 w-full border">
              <thead>
                <tr className="text-left bg-gray-100">
                  <th className="border p-2 w-[8rem] sm:w-[10rem] md:w-[13rem]">
                    Date Time
                  </th>
                  <th className="border p-2">Status</th>
                </tr>
              </thead>
              <tbody className="text-xs ">
                {checkpoints &&
                  checkpoints?.map((point, index) => {
                    const checkDate = point?.datetime
                      ?.split(" ")
                      ?.filter((item) => item !== "");
                    return (
                      <tr key={index} className="border-b-2 p-2">
                        <td className="p-2">
                          {checkDate[0]}
                          <br />
                          {`${checkDate[1]} ${checkDate[2]} ${checkDate[3]}`}
                          <br />
                          {checkDate[4]}
                        </td>
                        <td className="p-2 ">
                          <b>{point?.status}</b>
                          <br />
                          {point?.recievedby}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  </div>
);

export default TrackInfoComponent;
